import { Visibility } from '@mui/icons-material';
import { useBoundStore } from '../../../../stores';
import { IconButton } from '@mui/material';
import PermissionToRender from '../../../../components/Permission/PermissionToRender';
import { useNavigate } from 'react-router-dom';
import { Delete, Edit } from '@mui/icons-material';

function Columns(handleDelete) {
  const textPool = useBoundStore((state) => state.textPool);
  const toggleRightDrawer = useBoundStore((state) => state.toggleRightDrawer);
  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);
  const navigate = useNavigate();

  return [
    { field: 'name', headerName: textPool['İsim'], width: 120 },
    { field: 'surname', headerName: textPool['Soyisim'], width: 120 },
    { field: 'username', headerName: textPool['Kullanıcı ID'], width: 150 },
    //{ field: 'yerlemId', headerName: 'Yerlem ID', width: 150, notFilter: true  },
    // { field: 'email', headerName: textPool['Email'], width: 250 },

    {
      field: 'phone',
      headerName: textPool['GSM'],
      width: 150,
      filterEP: 'findByGsm',
    },
    {
      field: 'createdAt',
      headerName: textPool['Oluşturma Tarihi'],
      width: 200,
      notFilter: true,
      renderCell: (data) =>
        data.row.createdAt ? (
          <div>
            {data?.row?.createdAt
              ? new Date(data?.row?.createdAt).toLocaleString('tr')
              : ''}
          </div>
        )
          : '',
    },
    {
      field: 'actions',
      headerName: textPool['İşlemler'],
      width: 100,
      sortable: false,
      align: 'center',
      renderCell: (params) => {
        return (
          <div className="flex flex-row">
            {/* <IconButton
              onClick={() => {
                toggleLeftDrawer();
              }}
            >
              <Visibility />
            </IconButton> */}
            {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}>
              <IconButton
                onClick={() => {
                  navigate(`/definitions/users/user-record/${params.row.id}`);
                }}
              >
                <Visibility />
              </IconButton>
            </PermissionToRender> */}
            {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}> */}
            <IconButton
              onClick={() => {
                navigate(`/definitions/users/#${params.row.id}`);
                toggleLeftDrawer();
              }}
            >
              <Edit />
            </IconButton>
            {/* </PermissionToRender> */}
            {/* <PermissionToRender roleCanView={'KV_SUPERUSER'}> */}
            <IconButton onClick={() => handleDelete(params.row)}>
              <Delete />
            </IconButton>
            {/* </PermissionToRender> */}
          </div>
        );
      },
    },
  ];
}
export { Columns as columns };
